const initialState = {
    mediaPost: [],
  };
const mediaPostRoducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_MEDIA_POST":
        return { ...state, mediaPost: action.payload };
    case "DELETE_SOCIAL_MEDIA_POST":
      return (state = {
        ...state,
        mediaPost: state?.mediaPost?.filter(
          (mediaPost) => mediaPost._id !== action.payload?._id
        ),
      });
    default:
      return state;
  }
};

export default mediaPostRoducer;
